(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["journal-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('journal-share')) {
    customElements.define('journal-share', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const copyButton = this.querySelector('[data-copy]');
        const nativeButton = this.querySelector('[data-native]');
        const status = this.querySelector('[data-status]');
        const fallback = this.querySelector('[data-fallback]');
        const input = fallback.querySelector('input');
        const shareData = { title: this.dataset.title, url: this.dataset.url };

        copyButton.hidden = false;
        copyButton.addEventListener('click', async () => {
          status.textContent = '';
          copyButton.disabled = true;
          try {
            if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
            await navigator.clipboard.writeText(this.dataset.url);
            fallback.hidden = true;
            status.textContent = this.dataset.copied;
          } catch {
            fallback.hidden = false;
            input.focus();
            input.select();
            status.textContent = this.dataset.copyFallback;
          } finally {
            copyButton.disabled = false;
          }
        });

        if (typeof navigator.share === 'function' && window.isSecureContext) {
          nativeButton.hidden = false;
          nativeButton.addEventListener('click', async () => {
            status.textContent = '';
            nativeButton.disabled = true;
            try {
              await navigator.share(shareData);
            } catch (error) {
              if (error.name !== 'AbortError') status.textContent = this.dataset.shareFailed;
            } finally {
              nativeButton.disabled = false;
            }
          });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
